import getNestedProperty from '../GetNestedProperty'
import { postorderTraverser } from '../TreeTraverser'
import convertToNodeTree from './convertToNodeTree'
import defaultIsBlock from './isBlock'

const toArray = (arrayLikeObject) => Array.prototype.slice.call(arrayLikeObject)

const getNodeChildren = (node) =>
  toArray(getNestedProperty(node, 'childNodes') || [])

const textAccumulationBuilder = (textContainer, isBlock) => (node) => {
  if (getNestedProperty(node, 'nodeType') === Node.TEXT_NODE) {
    const text = getNestedProperty(node, 'textContent') || ''
    textContainer.result += text
  } else if (isBlock(node)) {
    textContainer.result += '\n'
  }
}

const htmlToText = (html) => {
  const container = {
    result: '',
  }

  const traverse = postorderTraverser({
    visit: textAccumulationBuilder(container, defaultIsBlock),
    getChildren: getNodeChildren,
  })

  const node = convertToNodeTree(html)
  traverse(node)

  return container.result.trim()
}

export default htmlToText
